const changeTextSoltera = (text) =>{
    if(text === "Soltero") return "Solter@";
    if(text === "Roommies") return "Roomies";
    return text;
}

export default changeTextSoltera;